import React, { useEffect } from "react";
import i18n from "i18next";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";

import { Button, Tooltip } from "@blueprintjs/core";
import { Callout } from "@blueprintjs/core";
import { front_basename } from "../..";

export class CameraButton extends React.Component {
  state = {
    isOpen: false,
    src: window.config.backend.video_proxy_route + this.props.eq,
    window: undefined,
  };

  render() {
    return (
      <div>
        <Tooltip
          content={
            this.state.isOpen ? (
              <Trans>hide equipment's camera</Trans>
            ) : (
              <Trans>show equipment's camera</Trans>
            )
          }
        >
          <Button
            icon={this.state.isOpen ? "cross" : "camera"}
            onClick={(e) => {
              e.stopPropagation();
              if (this.state.isOpen) {
                if (this.state.window !== undefined) {
                  this.state.window.close();
                  this.setState({ isOpen: false, window: undefined });
                }
              } else {
                let img = document.createElement("img");
                img.id = "imgId";
                img.src = this.state.src;
                const width = img.naturalWidth + 10;
                const height = img.naturalHeight + 150;

                try {
                  const _window = window.open(
                    `${front_basename}/camera/${this.props.srv}/${this.props.eq}`,
                    "Camera " + this.props.eq,
                    "width=" +
                      width +
                      ",height=" +
                      height +
                      "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no"
                  );
                  _window.focus();
                  _window.onbeforeunload = () => {
                    this.setState({ window: undefined, isOpen: false });
                  };
                  this.setState({ isOpen: true, window: _window });
                } catch (e) {
                  //console.log(e); //the window's script can fall in abort if the close is during the update of the screenshot
                }
              }
            }}
          />
        </Tooltip>
      </div>
    );
  }
}

export function Camera(props) {
  const { srvId, eqId } = useParams();
  if (srvId !== undefined && eqId !== undefined) window.resizeTo(700, 550);

  let id = eqId !== undefined ? eqId : props.eq;
  let srv = srvId !== undefined ? srvId : props.srv;
  const src = window.config.backend.video_proxy_route + srv + "/" + id;

  useEffect(() => {
    return () => {
      window.stop();
    };
  }, []);

  if (props.minimal === true)
    return (
      <img
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        draggable={false}
        src={src}
        alt={""} // invisible if not available
        className="transparent shrinkToFit"
      />
    );
  else
    return (
      <Callout
        title={
          <div className="flexbox-center-large">
            {eqId}
            <Button
              onClick={() => window.close()}
              icon="cross"
              minimal={true}
            />
          </div>
        }
        intent="primary"
        icon="camera"
      >
        <img
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
          draggable={false}
          src={src}
          alt={i18n.t("cannot retreive equipment's camera")}
          className="transparent shrinkToFit"
          onError={(err) => console.info(err)}
          onAbort={() => {
            console.info("ABORT");
          }}
        />
      </Callout>
    );
}
